import React, { useEffect, createElement } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function FAQSchema() {
  const {
    t,
    language
  } = useLanguage();
  useEffect(() => {
    const faqs = t('faq.items');
    if (!Array.isArray(faqs)) return;
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq: any) => ({
        '@type': 'Question',
        name: faq.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.a
        }
      }))
    };
    // Remove existing FAQ schema
    const existingScript = document.getElementById('faq-schema');
    if (existingScript) {
      existingScript.remove();
    }
    const script = document.createElement('script');
    script.id = 'faq-schema';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('faq-schema');
      if (el) el.remove();
    };
  }, [language, t]);
  return null;
}